import { render, staticRenderFns } from "./BundlePurchaseLayout1.vue?vue&type=template&id=5f57b896&"
import script from "./BundlePurchaseLayout1.vue?vue&type=script&lang=js&"
export * from "./BundlePurchaseLayout1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports